<script setup>
import { computed } from "vue"

const props = defineProps({
  started: {
    type: Number,
    required: true,
  },
  ends: {
    type: Number,
    required: true,
  },
  daysLeft: {
    type: Number,
    required: true,
  },
})

// blue: 30-8 days left, orange: 7-4, red: 3-0
const color = computed(() => {
  if (props.daysLeft <= 3) return "error"
  if (props.daysLeft <= 7) return "warning"
  return "primary"
})

const progress = computed(() => {
  const secPerDay = 60 * 60 * 24
  const totalDays = Math.round((props.ends - props.started) / secPerDay)
  return totalDays > 0 ? (totalDays - props.daysLeft) / totalDays * 100 : 100
})

const toLocaleDateStringOptions = {
  day: "numeric",
  month: "short",
  year: "numeric",
}
const startedAt = computed(() => new Date(props.started * 1000).toLocaleDateString(undefined, toLocaleDateStringOptions))
const endsAt = computed(() => new Date(props.ends * 1000).toLocaleDateString(undefined, toLocaleDateStringOptions))
</script>

<template>
  <v-card-text>
    <div class="d-flex justify-space-between align-center mb-2">
      <span class="text-body-large text-uppercase text-medium-emphasis">Free trial</span>
      <span
        class="text-body-large"
        :class="color === 'primary' ? 'text-medium-emphasis' : `text-${color}`"
      >
        {{ daysLeft }} {{ daysLeft === 1 ? "day" : "days" }} left
      </span>
    </div>
    <v-progress-linear
      :model-value="progress"
      :color="color"
      height="8"
      rounded
    />
    <div class="d-flex justify-space-between mt-2">
      <span class="text-body-large">Started {{ startedAt }}</span>
      <span class="text-body-large">Ends {{ endsAt }}</span>
    </div>
  </v-card-text>
</template>
